<template>
  <el-row justify="space-around">
    <el-col :span="10" style="padding: 20px 10px 10px 10px">
      <span class="pi_title_color">
        エスカレーション前の会話（{{
          this.$store.state.sysInit.unsolvedIssueList.length
        }}件の対応）
      </span>
      <!-- 履歴リスト -->
      <div style="padding: 15px; height: 100%;z-index: 1">
        <img style="height: 500px;width: -webkit-fill-available;"
          src="../assets/img/timeline.png" />
      </div>
      <div style="padding: 22px 10px 0px 10px; margin-top: 15px; max-height: 524px; width:398px; overflow-y: auto; position:absolute; z-index:2 ;top: 8% ">
        <el-collapse
          v-for="ticketInfo in this.$store.state.sysInit.unsolvedIssueList"
          class="ticket_collapse cti_collapse"
          v-model="activeTicket"
          @change="handleTicketCollapseChange(ticketInfo)"
          accordion>
          <el-card shadow="always" style="margin-bottom: 10px">
            <el-collapse-item :name="ticketInfo.issue_id" style="background-color: #ffffff">
              <template slot="title" style="height: 80px; background-color: #ffffff">
                <div style="width: 100%; padding-top: 3px; display: flex">
                  <div style="width: 15%">
                    <div class="user_headshot">
                      <div
                        v-if="
                          ticketInfo.tracker_name == 'AI VOICEBOT' ||
                          ticketInfo.tracker_name == 'AI CHATBOT'
                        ">
                        <img
                          v-if="ticketInfo.tracker_name == 'AI CHATBOT'"
                          class="img_operatorPi"
                          src="../assets/img/moppy1.png" />
                        <img v-else class="img_operatorPi" src="../assets/img/AIvoicebot.png" />
                      </div>
                      <div v-else>
                        <img class="img_operatorPi" :src="ticketInfo.assigned_to_logo_url" />
                      </div>
                    </div>
                  </div>
                  <div style="width: 80%; padding: 5px">
                    <span
                      v-if="ticketInfo.tracker_name == 'OPERATOR CHAT' || ticketInfo.tracker_name == 'AI ASSISTANT'"
                      style="margin-right: 5px;">
                      {{ ticketInfo.assigned_to_tel_num }}
                    </span>
                    <span style="font-weight:800; color: #232323">
                      {{ $utils.computeFullName(ticketInfo.assigned_to_lastname, ticketInfo.assigned_to_firstname) }}
                    </span>
                    <span>
                      {{
                        ticketInfo.tracker_name == "OPERATOR CHAT" ||
                        ticketInfo.tracker_name == "AI ASSISTANT"
                          ? ticketInfo.channel
                            ? "(オペレーター)"
                            : ""
                          : ""
                      }}
                    </span>
                    <div style="font-size: 12px; padding-top:3px">
                      {{ ticketInfo.created_on }}
                      {{ convertWaitedTime(ticketInfo.waited_time) }}
                    </div>
                  </div>
                </div>
              </template>
              <div style="padding: 5px; height: 150px">
                <div
                  :class="
                    ticketInfo.tracker_name == 'AI VOICEBOT'
                      ? 'history-card-items-style2'
                      : 'history-card-items-style1'
                  ">
                  <div>カテゴリタグ（登場回数）:</div>
                  <span v-for="(menu, index) in ticketInfo.category_tag_list" :key="index">
                    <span v-if="menu !== ''" style="padding: 5px">
                      <el-tag class="el-tag2" type="success">{{ menu }}</el-tag>
                    </span>
                  </span>
                </div>
                <div
                  :class="
                    ticketInfo.tracker_name == 'AI VOICEBOT'
                      ? 'history-card-items-style2'
                      : 'history-card-items-style1'
                  ">
                  <div>評価ワード（登場回数）:</div>
                  <span v-for="(word, index) in ticketInfo.wow_word" :key="index">
                    <span v-if="word !== ''" style="padding: 5px">
                      <el-tag class="el-tag2">{{
                        word
                      }}</el-tag>
                    </span>
                  </span>
                  <span v-for="(word, index) in ticketInfo.ng_word" :key="index">
                    <span v-if="word !== ''" style="padding: 5px">
                      <el-tag class="el-tag2" type="warning">{{
                        word
                      }}</el-tag>
                    </span>
                  </span>
                  <!-- <span v-for="(word, index) in ticketInfo.questioner_wow_word_list" :key="index">
                    <span v-if="word !== ''" style="padding: 5px">
                      <el-tag class="el-tag2">{{ word }}</el-tag>
                    </span>
                  </span>
                  <span v-for="(word, index) in ticketInfo.questioner_ng_word_list" :key="index">
                    <span v-if="word !== ''" style="padding: 5px">
                      <el-tag class="el-tag2" type="warning">{{ word }}</el-tag>
                    </span>
                  </span>
                  <span v-for="(word, index) in ticketInfo.operator_wow_word_list" :key="index">
                    <span v-if="word !== ''" style="padding: 5px">
                      <el-tag class="el-tag2" type="info">{{ word }}</el-tag>
                    </span>
                  </span>
                  <span v-for="(word, index) in ticketInfo.operator_ng_word_list" :key="index">
                    <span v-if="word !== ''" style="padding: 5px">
                      <el-tag class="el-tag2" type="danger">{{ word }}</el-tag>
                    </span>
                  </span> -->
                </div>
                <!-- TODO start 以后这个部分要查询相关的数据，做成时点相关功能未完成 -->
                <div
                  v-if="ticketInfo.tracker_name == 'AI VOICEBOT'"
                  class="history-card-items-style2">
                  <div style="width: 100%">
                    <span>直前回線：</span>
                    <span>03-6667-1111 (製品サポートデスク)</span>
                  </div>
                  <div style="width: 100%">
                    <span> 着信スキル：</span>
                    <span style="margin-right: 3px">
                      <el-tag class="el-tag2" type="warning">日本語</el-tag>
                    </span>
                    <span style="margin-right: 3px">
                      <el-tag class="el-tag2" type="info">新製品</el-tag>
                    </span>
                    <span style="margin-right: 3px">
                      <el-tag class="el-tag2">予約注文</el-tag>
                    </span>
                  </div>
                </div>
                <!-- TODO end 以后这个部分要查询相关的数据，做成时点相关功能未完成 -->
              </div>
            </el-collapse-item>
          </el-card>
        </el-collapse>
      </div>
    </el-col>
    <!-- 会話内容             :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data">-->
    <el-col :span="14">
      <div style="padding: 10px; margin-top: 10px; margin-right: 10px; min-height: 430px">
        <div class="wrapper_border" style="padding-left: 10px">
          <el-table
            :data="activeTicketHistoryArray"
            :show-header="false"
            height="560px"
            empty-text="会話を選択してください。">
            <el-table-column>
              <template slot-scope="scope">
                <div
                  style="padding-right: 5px"
                  class="message_msg_chat"
                  :class="{
                    left: scope.row.flag == 'right',
                    right: scope.row.flag == 'left',
                  }">
                  <div class="user_headshot" style="background-color: #f2f2f2">
                    <img :src="scope.row.logoUrl" />
                  </div>
                  <div class="user_msg">
                    <span>
                      <div class="speaker">
                        {{ scope.row.username }}
                      </div>
                      <div class="user_text" style="min-height: 28px; min-width: 30px;">
                        <span class="content-img-width" v-html="scope.row.text"></span>
                      </div>
                    </span>
                    <br />
                    <div v-if="scope.row.flag == 'right'" style="font-size: 12px; float: left">
                      {{ scope.row.messageTime.replaceAll("-","/") }}
                    </div>
                    <div v-else style="font-size: 12px; float: right">
                      {{ scope.row.messageTime.replaceAll("-","/") }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
const watson_logo = require("@/assets/img/moppy1.png");
const voicebot_logo = require("@/assets/img/AIvoicebot.png");
export default {
  data() {
    return {
      activeTicket: "",                // 選択された会話レコードのRedmineチケット番号
      activeTicketHistoryArray: [],    // 選択された会話内容
    };
  },
  watch: {
    // 応対引継ぎ情報リスト更新するされた場合、選択された会話レコードと会話内容をクリアする
    "$store.state.sysInit.unsolvedIssueList": function () {
      this.activeTicket = "";
      this.activeTicketHistoryArray = [];
    },
  },
  methods: {
    /*
     * OPとの会話履歴を処理する
     */
    splitAllTextForOpChat(allTextList, opLogoUrl) {

      // 会話履歴格式：
      // ゲスト（お問い合わせ者）:（2023-05-19 14:45:11）会話内容１
      // --------
      // テストop02（オペレーター）:（2023-05-19 14:45:26）会話内容２

      let sysName = "(オペレーター):";
      let userName = "(お問い合わせ者):";
      let svName = "(スーパーバイザー):";

      let hisStrList = [];
      allTextList.forEach((hisItem) => {
        // オペレーターの会話のレコードを作成する
        if (hisItem.toString().indexOf(sysName) != -1 || hisItem.toString().indexOf(svName) != -1 ) {
          sysName = hisItem.toString().indexOf(sysName) != -1 ? sysName:svName
          let time = hisItem
            .match(/\((.+?)\)/g)[1]
            .replace("\(", "")
            .replace("\)", "");

          let systemNameIndex = hisItem.toString().indexOf(sysName);
          let newSysName = hisItem.substring(0, systemNameIndex);
          let sysNameWithRole = newSysName + sysName;
          let hisItemStr = hisItem
            .replace(sysNameWithRole, "")
            .replace(/\(([^)]*)\)/g, "")
            .replace(/\n/gm, "<br>");

          if (hisItemStr.indexOf("<br>") == 0) {
            hisItemStr = hisItemStr.replace("<br>", "");
          }
          let sysObj = {
            flag: "left",
            text: hisItemStr,
            user: "system",
            username: newSysName,
            messageTime: time,
            logoUrl: opLogoUrl,
          };
          hisStrList.push(sysObj);
        }

        // ユーザーの会話のレコードを作成する
        if (hisItem.toString().indexOf(userName) != -1) {
          let time = hisItem
            .match(/\((.+?)\)/g)[1]
            .replace("\(", "")
            .replace("\)", "");

          let userNameIndex = hisItem.toString().indexOf(userName);
          let newUserName = hisItem.substring(0, userNameIndex);
          let userNameWithRole = newUserName + userName;
          let hisItemStr = hisItem
            .replace(userNameWithRole, "")
            .replace(/\(([^)]*)\)/g, "")
            .replace(/\n/gm, "<br>");

          let userObj = {
            flag: "right",
            text: hisItemStr,
            user: "user",
            username: newUserName,
            messageTime: time,
            logoUrl: this.$store.state.sysInit.userInfoForUnsolvedIssues.logoUrl,
          };
          hisStrList.push(userObj);
        }
      });
      this.activeTicketHistoryArray = hisStrList;
    },

    /*
     * AIとの会話履歴を処理する
     */
    splitAllTextForAiChat(allTextList, tracker) {

      // 会話履歴格式：
      // もっぴー:(2023-05-19 14:35:02) 本日はどのようなご用件でしょうか？お話しいただき、終わりましたら「#」を押してください。
      // --------
      // ゲスト(お問い合わせ者):(2023-05-19 14:35:19)会話内容。
      // マイルの三鷹です。
      // --------

      let sysName = "もっぴー:";
      let userName = "(お問い合わせ者):";

      let hisStrList = [];
      allTextList.forEach((hisItem) => {

        // AIの会話のレコードを作成する
        if (hisItem.toString().indexOf(sysName) != -1) {
          let time = hisItem
            .match(/\((.+?)\)/g)[0]
            .replace("\(", "")
            .replace("\)", "");
          let hisItemStr = hisItem
            .replace(/\(([^)]*)\)/g, "")
            .replace(sysName, "")
            .replace(/\n/gm, "<br>")
            .replace("<br><br>", "<br>");

          if (hisItemStr.indexOf("<br>") == 0) {
            hisItemStr = hisItemStr.replace("<br>", "");
          }

          let sysObj = {
            flag: "left",
            text: hisItemStr,
            user: "system",
            username: sysName.replace(":",""),
            messageTime: time,
            logoUrl: tracker == "AI CHATBOT" ? watson_logo : voicebot_logo,
          };
          hisStrList.push(sysObj);
        }

        // ユーザーの会話のレコードを作成する
        if (hisItem.toString().indexOf(userName) != -1) {
          let time = hisItem
            .match(/\((.+?)\)/g)[1]
            .replace("\(", "")
            .replace("\)", "");

          let userNameIndex = hisItem.toString().indexOf(userName);
          let newUserName = hisItem.substring(0, userNameIndex);
          let userNameWithRole = newUserName + userName;
          let hisItemStr = hisItem
            .replace(userNameWithRole, "")
            .replace(/\(([^)]*)\)/g, "")
            .replace(/\n/gm, "<br>");

          let userObj = {
            flag: "right",
            text: hisItemStr,
            user: "user",
            username: newUserName,
            messageTime: time,
            logoUrl: this.$store.state.sysInit.userInfoForUnsolvedIssues.logoUrl,
          };
          hisStrList.push(userObj);
        }
      });
      this.activeTicketHistoryArray = hisStrList;
    },

    /*
     * 選択されたレコードの会話履歴を作成する
     */
    handleTicketCollapseChange(row) {
      this.activeTicketHistoryArray = [];
      if (this.activeTicket && this.activeTicket !== "") {
        let allTextList = row.all_text
            .replaceAll("（", "(")
            .replaceAll("）", ")")
            .replaceAll("\r\n", "\n")
            .split("\n--------\n");

        if (row.tracker_name == "AI CHATBOT" || row.tracker_name == "AI VOICEBOT") {

          // 会話履歴格式：
          // もっぴー:(2023-05-19 14:35:02) 本日はどのようなご用件でしょうか？お話しいただき、終わりましたら「#」を押してください。
          // --------
          // ゲスト(お問い合わせ者):(2023-05-19 14:35:19)会話内容。
          // マイルの三鷹です。
          // --------

          // 会話履歴を処理して、画面に表示する
          this.splitAllTextForAiChat(allTextList, row.tracker_name);
        }
        if (row.tracker_name == "AI ASSISTANT" || row.tracker_name == "OPERATOR CHAT") {

          // 会話履歴格式：
          // ゲスト（お問い合わせ者）:（2023-05-19 14:45:11）会話内容１
          // --------
          // テストop02（オペレーター）:（2023-05-19 14:45:26）会話内容２

          // 会話履歴を処理して、画面に表示する
          this.splitAllTextForOpChat(allTextList, row.assigned_to_logo_url);
        }
      }
    },

    /*
     * Redmineの [UC2]SUPPORT WAITED TIME 項目を転換して画面に表示する
     */
    convertWaitedTime(waitedTime) {

      let waitedTimeStr = "";
      if (waitedTime && waitedTime !== ""){
        let waitedTimeArray = waitedTime.split(":");
        for (let i = 0 ; i < waitedTimeArray.length ; i++){
          // 時間・分・秒を「：」で区切り、最大単位のみ表示する
          let timeItem = waitedTimeArray[i];
          if(timeItem !== "00"){
            if(i == 0){
              waitedTimeStr = `（${timeItem}時間待ち）`
            } else if(i == 1){
              waitedTimeStr = `（${timeItem}分待ち）`
            } else {
              waitedTimeStr = `（${timeItem}秒待ち）`
            }
            break;
          }
        }
      }
      return waitedTimeStr
    },
  },
};
</script>

<style lang="scss" scoped>
.content-img-width ::v-deep(img) {
  width: 100%;
}

.history-card-items-style1 {
  height: 67px;
  width: 100%;
  overflow-y: auto;
}
.history-card-items-style2 {
  height: 45px;
  width: 100%;
  overflow-y: auto;
}
</style>
